import nodeViewDecorator from "./node-view-decorator.js";
import { sketchNodeViewDecorator } from "./sketch-viewer-decorator.js";
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from "./types.js";
const pluginTextColor = (config = {}) => {
  return {
    config,
    type: TEXT_COLOR_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};
const pluginTextHighlight = (config = {}) => {
  return {
    config,
    type: TEXT_HIGHLIGHT_TYPE,
    nodeViewDecorators: [sketchNodeViewDecorator]
  };
};
export {
  pluginTextColor,
  pluginTextHighlight
};
//# sourceMappingURL=viewer.js.map
